import { useEffect, useCallback } from 'react';
import {
  initAmplitude,
  trackAmplitudeEvent,
  updateUserProperties,
} from './initializationAmlitude';
import { LocalStorageApi } from '~/utils/storage';
import { USER_EMAIL, USER_ID } from '~/utils/storage/contants';

export function useAmplitude() {
  const environment = import.meta.env.VITE_APP_ENV;
  const amplitudeApiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
  const userId = LocalStorageApi?.getItem(USER_ID);
  const userEmail = LocalStorageApi?.getItem(USER_EMAIL);

  useEffect(() => {
    if (environment === 'develop') return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    initAmplitude(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      userId
        ? {
            email: userEmail,
            id: userId,
          }
        : undefined,
      amplitudeApiKey
    );
  }, [userId, amplitudeApiKey, environment]);

  const sendEvent = useCallback(
    (
      eventName: string,
      eventProps?: Record<string, string | number | boolean>
    ) => {
      if (environment === 'develop') return;
      trackAmplitudeEvent(eventName, eventProps);
    },
    [environment]
  );

  return sendEvent;
}

export function useUpdateUserProperties() {
  const environment = import.meta.env.VITE_APP_ENV;

  const updateProperties = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (properties: Record<string, any>) => {
      if (environment === 'develop') return;
      updateUserProperties(properties);
    },
    [environment]
  );

  return updateProperties;
}
